import SofdcarFavicon from '../../../../../../../features/shared/assets/favicons/sofdcar-favicon.ico';
import Sparq from '../../../../../../../features/shared/assets/favicons/sparq-favicon.ico';
import { ThemeEnum } from '../../../../../../theme/enums/theme.enum';
import { ThemeConfigModel } from '../../../../models/theme-config.model';

export const themeConfigDef = new Map<ThemeEnum, ThemeConfigModel>([
  [
    ThemeEnum.SPARQ,
    {
      appTitle: 'SPARQ store',
      faviconPath: Sparq,
    },
  ],
  [
    ThemeEnum.SOFDCAR,
    {
      appTitle: 'Sofdcar',
      faviconPath: SofdcarFavicon,
    },
  ],
]);
